<template>
  <PageContentLayoutOnly role="region">
    <div class="level-left level-item title">{{ $t('directoryContact.title') }}</div>
    <ModernTable
      :region="region"
      :filters="filters"
      :rows="rows"
      :columns="columns"
      :pagination="{
        perPage: 12
      }"
      :loading="loading"
      headerColor="#FFF"
      condensed
    >
      <template v-slot:header>
        <div :style="{ width: '100%', height: '60px' }">
          <b-button
            type="is-ghost"
            @click="filters.show = !filters.show"
            :style="{ float: 'right', background: 'none', border: 0 }"
            :class="'filter-button ' + (filters.show ? 'active' : '')"
          >
            <b-icon pack="mdi" icon="filter-outline" size="is-small" style="display: inline-block">
            </b-icon>
            <div style="display: inline-block">Filter</div>
          </b-button>
        </div>
      </template>
    </ModernTable>
  </PageContentLayoutOnly>
</template>

<script>
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import ModernTable from '@/components/tables/Modern/Table'
import { methods } from './keys/methods'
import { data } from './keys/data'
import { computed } from './keys/computed'
import { watch } from './keys/watch'

export default {
  name: 'DirectoryContact',
  components: {
    PageContentLayoutOnly,
    ModernTable
  },

  data,
  computed,
  methods,
  watch,

  mounted() {
    this.reload()
  },

  i18n: {
    messages: {
      en: { directoryContact: { title: 'Homeowner Directory' } }
    }
  }
}
</script>

<style></style>
